import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

/**
 * 采购付款单模块——需求 FR-FN-01~04 / 5.4 / 5.2
 * 采购单/自采单审批通过后由后端自动生成付款单，财务（27）统一处理
 * 注意：以下接口路径为前端预留，具体以后端为准（TODO 待后端联调确认）
 */

// 付款单列表（分页，来源类型/状态/单号/供应商/时间筛选）
export function getPaymentOrderList(data) {
    return request({
        url: serviceName + `/payment_order_list`,
        method: 'post',
        data: data
    })
}

// 查询付款单详情（含关联采购单/自采单与付款流水）
export function queryPaymentOrder(data) {
    return request({
        url: serviceName + `/query_payment_order`,
        method: 'post',
        data: data
    })
}

// 财务处理付款单（付款/部分付款，记录付款流水）
export function processPaymentOrder(data) {
    return request({
        url: serviceName + `/process_payment_order`,
        method: 'post',
        data: data
    })
}

// 财务驳回付款单
export function rejectPaymentOrder(data) {
    return request({
        url: serviceName + `/reject_payment_order`,
        method: 'post',
        data: data
    })
}

// 付款统计（按供应商/部门/商机，FR-FN-04 P1）
export function paymentStatistics(data) {
    return request({
        url: serviceName + `/payment_statistics` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}
